module.exports = __webpack_public_path__ + "img/weidu1.f3f3d20c.png";